"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'tools.personalData.name': '个人数据检测',
    'tools.personalData.description': '从用户消息中提取和分类个人数据，如电话号码、电子邮件、地址、姓名等',
};
